import { html, nothing, render } from "lit-html";
import { when } from "lit-html/directives/when.js";
import { keyed } from "lit-html/directives/keyed.js";
import { RandomSelector } from "@escapio/portal/components/hotel-list/RandomSelector";
import { matchesCurrency } from "@escapio/portal/components/deals/matches-currency";
import { onChangeCurrency, travelData } from "@escapio/portal/state/travelData";
import { translate } from "@escapio/shared/l10n/translate";
import connect from "@escapio/shared/data-store/connect";
import { data } from "@escapio/shared/state/payload";
import { store } from "./DataStore";
import "../deals/Hotel";
import "../deals/Article";

const { hotel_list: hotels } = data;

customElements.define(
	"esc-hotel-list-deals",
	class extends connect(HTMLElement, store) {
		constructor() {
			super();
			this.preselectedDealId = null;
		}

		connectedCallback() {
			super.connectedCallback();
			onChangeCurrency(() => this.render());
			document.addEventListener("hotelListPaginated", () => this.render());
			this.render();
		}

		update({ preselectedDealId }) {
			if (preselectedDealId !== this.preselectedDealId) {
				this.preselectedDealId = preselectedDealId;
				this.render();
			}
		}

		render() {
			const deals = ["hotel-deals", "article-deals"]
				.map(attr => this.getAttribute(attr))
				.map(json => JSON.parse(json))
				.flat();

			const deal = new RandomSelector()
				.setCandidates(deals)
				.setPreselected(this.preselectedDealId)
				.fulfillsCondition(matchesCurrency)
				.select();

			if (!deal) {
				render(nothing, this);
				return;
			}

			const template = when(
				deal.hotel_id,
				() => {
					deal.hotel = hotels.find(({ id }) => id === deal.hotel_id);
					return html`<span class="hotel-list__deal-info"
							>${translate("hotel_list_deal_advert_label")}</span
						>
						<esc-hotel-deal
							class="hotel-list-item"
							.deal=${deal}
							event-category="Liste"
							event-label="${this.eventLabel}"
						></esc-hotel-deal>`;
				},
				() =>
					html`<span class="hotel-list__deal-info"
							>${translate("hotel_list_deal_advert_label")}</span
						>
						<esc-article-deal
							class="hotel-list-item"
							.deal=${deal}
							event-category="Liste"
						></esc-article-deal>`,
			);
			render(
				keyed(`${travelData.currency}-${JSON.stringify(deal)}`, template),
				this,
			);
		}

		get eventLabel() {
			return this.getAttribute("event-label");
		}
	},
);
